import {
    EmptyState,
    EmptyStateDescription,
    EmptyStateIcon,
    EmptyStateTitle,
} from '@plato/ui/components/empty-state';
import type { FC } from 'react';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { PlatoPhilosopherIcon } from '../assets/plato-philosopher-icon.tsx';

/**
 * Shown in place of the transcript before the first question. `m-auto` centres
 * it in the scroller, which stretches to the viewport height while empty.
 */
export const AskPlatoEmptyState: FC = () => {
    const { t } = useLocale('common');

    return (
        <EmptyState className="m-auto max-w-xs">
            <EmptyStateIcon>
                <PlatoPhilosopherIcon className="h-10 w-10 text-blue-600" />
            </EmptyStateIcon>
            <EmptyStateTitle>{t('ask_plato__empty_title')}</EmptyStateTitle>
            <EmptyStateDescription>{t('ask_plato__empty_description')}</EmptyStateDescription>
        </EmptyState>
    );
};
